import React, { Component, FC, useEffect, useState, useRef } from 'react';
import { render } from 'react-dom';
import './ToggleComponent.css';
import axios from "../../datasource/axios";
import { MANAGEDROPDOWN_URL} from '../../constants';
import { hideLoader } from "../../datasource/msal";
import { getAdminDropdownValues, getLegalEntityMappings } from '../newClientRequest/dropdownService';
import { Toast } from 'primereact/toast';

export const ToggleSwitch = (props:any) => { 
interface DropdownRow {
  id: number;
  name: string;
  status: boolean;
  updatedDate: string;
}

class DropdownRowClass {
  constructor(
    public id: number,
    public name: string,
    public status: boolean,
    public updatedDate: string
  ) {}
}

interface SwitchProps {
  isOn: boolean;
  handleToggle: (id: number) => void;
  id: number;
}

const [tableValues, setTableValues] =  useState<any[]>([]);
const [dropdownRows, setdropdownRows] =  useState<DropdownRowClass[]>([]);
const [selectedTableName, setSelectedTableName] = useState('');
const [showLoader, setShowLoader] = useState(false);
const [spinnerClassName, setSpinnerClassName] = useState("");
const toast = useRef<any>(null);

useEffect(() => {
    setTableValues(props.tableData);
    setSelectedTableName(props.tableName);
    var test = props.tableData;
    //remove any existing rows first
    dropdownRows.length = 0;
    test.map((row: DropdownRow) => {
        const { id, name, status, updatedDate } = row; //destructuring
        //const [value, setValue] = useState(false);
        let x = new DropdownRowClass(id, name, status, updatedDate);
        dropdownRows.push(x);
      });
  }, [props.tableData]);


  const Switch: FC<SwitchProps> = ({ isOn, handleToggle, id }) => {
  return (
    <>
      <div className="toggle-switch">
      <input
        checked={isOn}
        onChange={ async () => handleToggle(id)} //call handleToggle using id
        className="checkbox"
        id={`react-switch-new${id}`} // Make it unique by adding id
        type="checkbox"
      />
      <label
        className="label"
        htmlFor={`react-switch-new${id}`} // Make it unique by adding id
      >
          <span className="inner" />
          <span className="switch" />
      </label>
      </div>
    </>
  );
};

const columnHeaders = [
    "Value",
    "Status",
    "Last Updated"
];
const sortHeaders = [
    "name",
    "status",
    "updatedDate"
];

const table = document.getElementById('records');

const toggleValue  = async (value: any, status: any) => {
    var tableDetails = {
        'TableName': selectedTableName,
        'Additions': [],
        'StatusDetails': {'value': value, 
                          'status': status
                         }
    };
 
    let BASE_URL =  process.env.REACT_APP_API_URI;
    let url=BASE_URL + MANAGEDROPDOWN_URL;
 
    const res:any = await new Promise((resolve, reject) => {
    try {
    axios.postRequest(url, tableDetails) 
        .then((res: any) => {
            setShowLoader(false);
            setSpinnerClassName('divSpinner');
            resolve(res);
        })
        .catch((err: any) => {
            setShowLoader(false);
            setSpinnerClassName('divSpinner');
            resolve(err);
        });
    } catch (error) {
        setShowLoader(false);
        setSpinnerClassName('divSpinner');
        reject(error);
    }
    }); // end res:any

    if (res.status == "Success") {
    //retrieve list of values for selected table
    let input: HTMLInputElement;
    input = document.getElementById("searchInput") as HTMLInputElement;
    input.value = "";
    if (selectedTableName === "legal_entities") {
        let response: any = await getLegalEntityMappings();
        let codes = response?.codes;
        setTableValues(codes);
        dropdownRows.length = 0;
        codes.map((row: DropdownRow) => {
          const { id, name, status, updatedDate } = row; //destructuring
          //const [value, setValue] = useState(false);
          let x = new DropdownRowClass(id, name, status, updatedDate);
          dropdownRows.push(x);
        });
    }else {
        let response: any = await getAdminDropdownValues(selectedTableName);
        let codes = response?.codes;
        setTableValues(codes);
        dropdownRows.length = 0;
        codes.map((row: DropdownRow) => {
          const { id, name, status, updatedDate } = row; //destructuring
          //const [value, setValue] = useState(false);
          let x = new DropdownRowClass(id, name, status, updatedDate);
          dropdownRows.push(x);
        });     
    }
     }else {
        toast.current.show({severity: 'error', summary: 'Error', detail : "Error updating status", life : 3000 });
    }
}

function sortTable(table: any, col: any, reverse: any) {
  var tb = table.tBodies[0], // use `<tbody>` to ignore `<thead>` and `<tfoot>` rows
      tr = Array.prototype.slice.call(tb.rows, 0), // put rows into array
      i;
  reverse = -((+reverse) || -1);
  if (col === 0 || col === 2)
	{
    var t = document.getElementById ("records");
    var headerCells = t?.getElementsByTagName("th");
		if (reverse == 1) {
      if (headerCells && headerCells.length > 0) {
        var text = headerCells[col].innerHTML;
        const myArray = text.split("&nbsp;&nbsp;");
        headerCells[col].innerHTML = myArray[0] +"&nbsp;&nbsp;&#8593;";
        if (col === 0) {
          var text = headerCells[2].innerHTML;
          const myArray = text.split("&nbsp;&nbsp;");
          headerCells[2].innerHTML = myArray[0];
        }else {
          var text = headerCells[0].innerHTML;
          const myArray = text.split("&nbsp;&nbsp;");
          headerCells[0].innerHTML = myArray[0];
        }
	    }
		}else {
      if (headerCells && headerCells.length > 0) {
        var text = headerCells[col].innerHTML;
        const myArray = text.split("&nbsp;&nbsp;");
        headerCells[col].innerHTML = myArray[0] +"&nbsp;&nbsp;&#8595;";
        if (col === 0) {
          var text = headerCells[2].innerHTML;
          const myArray = text.split("&nbsp;&nbsp;");
          headerCells[2].innerHTML = myArray[0];
        }else {
          var text = headerCells[0].innerHTML;
          const myArray = text.split("&nbsp;&nbsp;");
          headerCells[0].innerHTML = myArray[0];
        }
      }
		}
	}
  tr = tr.sort(function (a, b) { // sort rows
      return reverse // `-1 *` if want opposite order
          * (a.cells[col].textContent.trim() // using `.textContent.trim()` for test
      .localeCompare(b.cells[col].textContent.trim(), undefined, {numeric: true})
             );
  });
  for(i = 0; i < tr.length; ++i) tb.appendChild(tr[i]); // append each row in order
}

function makeSortable(table: any) {
  var th = table.tHead, i;
  th && (th = th.rows[0]) && (th = th.cells);
  if (th) i = th.length;
  else return; // if no `<thead>` then do nothing
  while (--i >= 0) (function (i) {
      var dir = 1;
      th[i].addEventListener('click', function () {sortTable(table, i, (dir = 1 - dir))});
  }(i));
}

function makeAllSortable() {
  var parent =  document.body;
  var t = parent.getElementsByTagName('table'), i = t.length;
  while (--i >= 0) makeSortable(t[i]);
}

class Table extends React.Component {
  state = {
    dropdownRows
  };

  handleToggle = (id: number) => {
    this.setState({
        dropdownRows: this.state.dropdownRows.map(async (std: DropdownRow) => {
        
        if (std.id === id) {
          let x = { ...std, status: !std.status };
          //update database
            await toggleValue(std.name, !std.status);
            return x;
        } else {
          return std;
        }
      }),
    });
  };

  renderTableHeader() {
    return columnHeaders.map((key, index) => {
      if (index === 1) {
        return <th>{key}</th>;
      }else  if (index === 0) {
        return <th className="showPointer">{key}&nbsp;&nbsp;&#8593;</th>;
      }
      else {
        return <th className="showPointer">{key}</th>;
      }
    });   
  }

  renderTableData() {
  makeAllSortable();

    return this.state.dropdownRows.map((row: DropdownRow, index) => {
      const { id, name, status, updatedDate } = row; //destructuring
      return (
        <tr key={id}>
          <td>{name}</td>
          <td>
            <Switch isOn={status} id={id} handleToggle={this.handleToggle}  />
          </td>        
        <td>{updatedDate}</td>         
        </tr>
      );
    });
  }

  render() {
    return (
      <div>
        {/* <input type="text" id="searchInput" onKeyUp={searchFunction} placeholder="Search for a value..." title="Type in any value"/> */}
      <div className="table-wrap">
        <div id="dRows">
          <Toast ref={toast} /> 
          
          <table id="records"  className="tableFixHead">
              <thead>
              <tr  className="header">{this.renderTableHeader()}</tr>
              </thead>
              <tbody>
              {this.renderTableData()}
              </tbody>
          </table>
        </div>       
      </div></div>
     );
     
  }
}

const someElement = document.getElementById("dRows");
if (someElement) {
    render(<Table />, document.getElementById('dRows'));
}
return (
    <Table />
    )
}